/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */

// eslint-disable-next-line no-unused-vars
import { node } from "venuescanner-js/tools/jsx";
import mimetype from "venuescanner-backend/app/classes/assets/mimetype";
import { confirm } from "venuescanner-js/vanilla/components/confirm";

export const Attachment = ({ attachment, removeItem }) => {
  const filename = attachment.filename.valueOf();
  const ext = filename.match(/\.([^\.])$/);
  const icon = attachment.icon.valueOf()
    ? attachment.icon
    : mimetype.getFile((ext && ext[1]) || "file");
  return (
    <div class="file-selector">
      <vs-chk
        checked={attachment.checked}
        onVschange={(e) => {
          attachment.checked.set(e.detail);
        }}
      >
        <div class="file-selector-content">
          {/* <img src={icon} /> */}
          <img
            class="file-selector-content__icon"
            src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/attachment-image.png"
            alt="attached file icon"
          ></img>
          <div>{attachment.filename}</div>
          <span
            class="delButton"
            onClick={async () => {
              confirm(
                `Are you sure you wish to remove "${attachment.filename}" permanently?`,
                async () => {
                  if (await removeItem(attachment)) {
                    attachment.parent.remove(attachment);
                  }
                },
                () => {}
              );
            }}
          ></span>
        </div>
      </vs-chk>
    </div>
  );
};
